import { api } from './http'

export interface OrderCreate {
  runner_id: number
  event_id: number
  companion_id?: number
  target_time?: string
  price: number
}

export interface Order {
  id: number
  runner_id: number
  event_id: number
  companion_id?: number
  target_time?: string
  price: number
  status: string
  created_at: string
  updated_at: string
}

export const ordersApi = {
  list: (
    page = 1,
    pageSize = 20,
    params?: { runner_id?: number; companion_id?: number; status?: string; start?: string; end?: string }
  ) => {
    const qs = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    if (params?.runner_id) qs.set('runner_id', String(params.runner_id))
    if (params?.companion_id) qs.set('companion_id', String(params.companion_id))
    if (params?.status) qs.set('status', params.status)
    if (params?.start) qs.set('start', params.start)
    if (params?.end) qs.set('end', params.end)
    return api.get<{ total: number; page: number; page_size: number; items: Order[] }>(`/orders?${qs.toString()}`)
  },
  create: (body: OrderCreate) => api.post<Order>('/orders', body),
}
